export const Copyright = () => (
  <div className="copyright">
    Copyright LincolnStudy © 2024. All rights reserved.
  </div>
);
